export enum Environment {
    HOSPITALITY = 'HOSPITALITY',
    INTEGRATION = 'INTEGRATION',
    PORTAL = 'PORTAL',
    B2B = 'B2B',
}

export const getEnvironmentAsString = (environment: Environment): string => {
    switch (environment) {
        case Environment.HOSPITALITY:
            return 'Hospitality';
        case Environment.INTEGRATION:
            return 'Integration';
        case Environment.PORTAL:
            return 'Portal';
        case Environment.B2B:
            return 'B2B';
        default:
            return environment;
    }
};
